let menuButton = document.querySelector('.yadro-menu__hamburger');
let mainMenu = document.querySelector('.yadro-menu__container');
let header = document.querySelector('.yadro-header');
let hamburger = document.querySelector('#yadro-menu__button');

// TODO Add current link by JS

if (menuButton && mainMenu) {
    mainMenu.classList.remove('is-active');
    document.body.classList.remove('menu-is-open');
    menuButton.addEventListener('click', () => {
        if (hamburger.checked) {
            mainMenu.classList.remove('is-active');
            document.body.classList.remove('menu-is-open');
        } else {
            mainMenu.classList.add('is-active');
            document.body.classList.add('menu-is-open');
        }
    })
}

if (hamburger) {
    hamburger.checked = '';
}

let showSubMenuButtons = document.querySelectorAll('.yadro-menu__show-sub-menu');
let hideSubMenuButtons = document.querySelectorAll('.yadro-menu__hide-sub-menu');

if (showSubMenuButtons) {
    showSubMenuButtons.forEach(element => {
        element.addEventListener('click', () => {
            let nextMenu = element.closest('.menu-item');
            let activeMenu = document.querySelector('.menu-item.is-active');
            if (activeMenu != undefined && activeMenu != nextMenu) {
                activeMenu.classList.remove('is-active');
            }
            nextMenu.classList.add('is-active');
            mainMenu.classList.add('is-active-sub-menu');
        })
    });
}

if (hideSubMenuButtons) {
    hideSubMenuButtons.forEach(element => {
        element.addEventListener('click', () => {
            let nextMenu = element.closest('.menu-item');
            nextMenu.classList.remove('is-active');
            mainMenu.classList.remove('is-active-sub-menu');
        })
    });
}

// Current menu item
let currentLocation = window.document.location.toString().replace(window.document.location.search, '');
// 1. Link in the main menu
let activeLink = document.querySelector('.yadro-menu__link__title.--main a[href="' + currentLocation + '"]');
let currentSubLink = null;
// 2. Submenu item
if (!activeLink) {
    currentSubLink = document.querySelector('.yadro-menu__link__title a[href="' + currentLocation + '"]');
}
// 3. Partial match
if (!activeLink && window.document.location.pathname != '') {
    currentLocation = currentLocation.replace(window.document.location.pathname, '');
    currentSubLink = document.querySelector('.yadro-menu__link__title a[href*="' + currentLocation + '"]');
}
if (currentSubLink) {
    activeLink = currentSubLink.closest('.yadro-menu > .menu-item');
}
if (activeLink) {
    activeLink.classList.add('current-menu-item');
}
